import React from 'react';
import { motion } from 'framer-motion';
import { FaHeadphones, FaMicrophone, FaRecordVinyl } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import SEO from './SEO';
import './About.css';

const About = () => {
  const { t } = useLanguage();

  return (
    <>
      <SEO 
        title="About"
        description="Learn more about Sergey Levitskiy - Professional DJ and Music Producer. Experience in Commercial and Underground Electronic Music."
        keywords="Sergey Levitskiy biography, DJ profile, Music Producer, Electronic Music artist"
      />
      <div className="about-page">
      {/* Креативные эффекты фона для About */}
      <div className="about-particles"></div>
      <div className="about-grid-pattern"></div>
      
      <motion.div
        className="about-content"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <motion.h1
          className="about-title"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, type: "spring" }}
        >
          
        </motion.h1>

        <motion.div
          className="about-section"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <div className="about-icon">
            <FaMicrophone />
          </div>
          <h2>{t('about.name')}</h2>
          <p>
            {t('about.description')}
          </p>
        </motion.div>

        <div className="about-grid">
          <Link to="/commercial" style={{ textDecoration: 'none', color: 'inherit' }}>
            <motion.div
              className="about-card"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.4 }}
              whileHover={{ scale: 1.05, y: -5 }}
              style={{ cursor: 'pointer' }}
            >
              <FaHeadphones className="card-icon" />
              <h3>{t('about.commercial')}</h3>
              <p>
                {t('about.commercialDesc')}
              </p>
            </motion.div>
          </Link>

          <Link to="/underground" style={{ textDecoration: 'none', color: 'inherit' }}>
            <motion.div
              className="about-card"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.5 }}
              whileHover={{ scale: 1.05, y: -5 }}
              style={{ cursor: 'pointer' }}
            >
              <FaRecordVinyl className="card-icon" />
              <h3>{t('about.underground')}</h3>
              <p>
                {t('about.undergroundDesc')}
              </p>
            </motion.div>
          </Link>
        </div>

        <motion.div
          className="about-section"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
        >
          <h2>{t('about.experience')}</h2>
          <p>
            {t('about.experienceDesc')}
          </p>
        </motion.div>
      </motion.div>
    </div>
    </>
  );
};

export default About;

